import type { ScoutingCounts } from '@/marketing/models/campaignScouting';
import { SCOUTING_FILTERS, type ScoutingFilter } from './scoutingView';

interface ScoutingFiltersProps {
  value: ScoutingFilter;
  onChange: (value: ScoutingFilter) => void;
  panelId: string;
  counts?: ScoutingCounts | undefined;
}
export function ScoutingFilters({ value, onChange, panelId, counts }: ScoutingFiltersProps) {
  return (
    <div role="tablist" aria-label="Scouting status" className="tw-flex tw-flex-wrap tw-gap-1 tw-border-b">
      {SCOUTING_FILTERS.map((status, index) => (
        <button
          key={status}
          type="button"
          role="tab"
          id={`${panelId}-${status}`}
          aria-controls={panelId}
          aria-label={status}
          aria-description={counts ? `${counts[status]} creators in the whole campaign` : undefined}
          aria-selected={value === status}
          tabIndex={value === status ? 0 : -1}
          className={`tw-border-b-2 tw-px-4 tw-py-2 tw-text-sm ${value === status ? 'tw-border-primary tw-font-semibold tw-text-primary' : 'tw-border-transparent tw-text-muted-foreground hover:tw-text-foreground'}`}
          onClick={() => onChange(status)}
          onKeyDown={(event) => {
            const nextIndex =
              event.key === 'ArrowRight'
                ? (index + 1) % SCOUTING_FILTERS.length
                : event.key === 'ArrowLeft'
                  ? (index - 1 + SCOUTING_FILTERS.length) % SCOUTING_FILTERS.length
                  : event.key === 'Home'
                    ? 0
                    : event.key === 'End'
                      ? SCOUTING_FILTERS.length - 1
                      : null;
            if (nextIndex === null) {
              return;
            }
            event.preventDefault();
            const next = SCOUTING_FILTERS[nextIndex];
            if (next) {
              onChange(next);
              event.currentTarget.parentElement
                ?.querySelectorAll<HTMLButtonElement>('[role="tab"]')
                [nextIndex]?.focus();
            }
          }}
        >
          {status}
          {counts ? ` (${counts[status]})` : ''}
        </button>
      ))}
    </div>
  );
}
